import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const TrademarkSearch = () => {
  const usps = [
    {
      title: 'Comprehensive Database Search',
      description: 'We search federal USPTO databases, state registrations, and common law sources to identify potential conflicts. Uncover issues before you invest in your brand.'
    },
    {
      title: 'Risk Assessment Report',
      description: 'Receive detailed analysis of potential conflicts with actionable recommendations. Our expert reports help you make informed decisions about your trademark strategy.'
    },
    {
      title: 'Save Time & Money',
      description: 'Identify potential issues early to avoid costly rebranding or legal disputes. A thorough search is the most important first step in trademark registration.'
    },
    {
      title: 'Expert Analysis',
      description: 'Our trademark specialists review search results and provide strategic guidance on likelihood of approval, alternative options, and best paths forward.'
    }
  ];

  const whyChooseContent = {
    about: 'A comprehensive trademark search is essential before filing your application. Our search services identify existing trademarks that could block your registration or lead to infringement claims, saving you time, money, and legal headaches down the road.',
    intro: 'Don\'t risk your brand investment. Trademark Vector provides professional trademark searches that uncover potential conflicts before you file.',
    paragraph1: 'Using advanced search tools and expert analysis, we examine federal registrations, state trademarks, common law marks, and business names to give you a complete picture of your trademark\'s availability and registrability.',
    paragraph2: 'Our search reports are clear, comprehensive, and include strategic recommendations from experienced trademark attorneys. Move forward with confidence knowing exactly where your mark stands.'
  };

  return (
    <ServiceTemplate
      title="Comprehensive Trademark Search"
      subtitle="Avoid Costly Conflicts with Professional Trademark Search Services"
      description="Ensure your trademark is available before filing. Our comprehensive search services examine federal, state, and common law sources to identify potential conflicts and assess registration success."
      heroImage="https://images.unsplash.com/photo-1659869764315-dc3d188141fe"
      aboutImage="https://images.unsplash.com/photo-1588600878108-578307a3cc9d?w=800"
      serviceId="trademark-search"
      metaTitle="Comprehensive Trademark Search Services | Trademark Vector"
      metaDescription="Avoid costly conflicts before you file. We search USPTO, state & common-law databases and deliver attorney-reviewed risk reports on your mark."
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default TrademarkSearch;
